module.exports = __webpack_public_path__ + "img/exit.f0a2d4fe.svg";